import abi from "./Transactions.json";

export const contractAddress = "0x563b2E1aAa4deD43E77A4Ec82f7f75afb1219970";
export const contractABI = abi.abi;
